module.exports = __webpack_public_path__ + "img/institutional_xincheng.d2fbbca7.png";